import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutageService } from '../outage.service';

@Component({
  selector: 'app-outage',
  templateUrl: './outage.component.html',
  styleUrls: ['./outage.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class OutageComponent implements OnInit {
  /** Status from service (automatic) */
  private serviceStatus: 'planned' | 'in-progress' | null = null;

  /** Manual override status (set this to override) */
  manualOverride: 'planned' | 'in-progress' | null = null;

  /** Final status used for display */
  get status(): 'planned' | 'in-progress' | null {
    return this.manualOverride ?? this.serviceStatus;
  }

  constructor(private outageService: OutageService) {}

  ngOnInit(): void {
    this.outageService.status$.subscribe(status => {
      this.serviceStatus = status;
    });
  }

  /** Dismisses the outage UI and clears manual override (optional) */
  dismiss(): void {
    this.manualOverride = null;
    this.outageService.dismiss(); // clears service-side status too
  }
}
